import { injectIntl } from 'react-intl';
import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { VBox } from '../../../components/Box';
import { FormField } from '../../../components/FormFields';
import { Input } from '../../../components/Input';
import { normalizeSearchString } from '../../../utils/normalizeSearchString';
import { Cell, List, Row } from '../../../components/List';
import { vehicleSearch } from '../actions';
import { selectWork } from '../../Api/selectors';
import { REQUEST_VEHICLES } from '../constants';
import { Loader } from '../../../components/Loader';
import { formatLicensePlate } from '../../../utils/string';
import { parseVehicle } from '../helpers';

const STATE = {
  string: '',
  active: false,
};

const Container = styled.div`
  .form-controlField,
  .form-controlField > div {
    width: 100%;
  }
  .results {
    max-height: 60vh;
    overflow-y: auto;
    width: 100%;
  }
`;

/* eslint-disable react/prefer-stateless-function */
class VehicleSelectionComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  reset() {
    this.setState({ ...STATE });
  }

  getHomeAddressCity(company) {
    const addressTypeId = this.props.addressTypes.filter(t => t.name === 'home')[0]?.id;
    return company?.addresses?.filter(a => a?.typeId == addressTypeId)[0]?.city;
  }

  onStringChange(evt) {
    let string = evt.target.value;
    this.setState({ string });
    this._t = this.timeout(this.search.bind(this), 300, this._t);
  }

  search() {
    const string = normalizeSearchString(this.state.string);
    this.props.search(string, result => {
      this.setState({
        result: result.items?.map(parseVehicle),
      });
    });
  }

  render() {
    return (
      <Container>
        <VBox>
          <FormField label={this.props.label || null}>
            <Input
              leftDecoration={this.props.work ? <Loader small /> : null}
              name="string"
              onChange={this.onStringChange.bind(this)}
              value={this.state.string}
              placeholder={this.lblStr('vehicle.search.placeholder')}
            />
          </FormField>
          {this.renderResult()}
        </VBox>
      </Container>
    );
  }

  renderResult() {
    if (!this.state.result) return '';
    return (
      <div className="results">
        <List>
          {this.state.result.map(vehicle => (
            <Row
              key={vehicle.id}
              onClick={() => {
                this.setState({ result: null });
                if (this.props.onSelect) this.props.onSelect(vehicle);
              }}
            >
              <Cell>
                <span style={{ fontWeight: 400, opacity: '0.6' }}>{vehicle.id}</span>
              </Cell>
              <Cell>{formatLicensePlate(vehicle.regplate)}</Cell>
              <Cell>{vehicle.vin}</Cell>
            </Row>
          ))}
        </List>
      </div>
    );
  }
}

VehicleSelectionComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWork(REQUEST_VEHICLES),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    search(string, callback) {
      dispatch(vehicleSearch(string, callback));
    },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const VehicleSelection = compose(
  withConnect,
  withRouter,
  injectIntl,
)(VehicleSelectionComp);
